import { Modal } from 'antd';
import download from 'downloadjs';
import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../../../api';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import { RootState } from '../../../../store/rootReducer';
import HSButton from '../../../common/Button';
import LinkButton from '../../../common/LinkButton';
import MessageActions from '../../../message/redux/actions';
import { ONBOARDING_PATH } from '../../onboarding/Onbording';

const DownloadHistoricalDeals: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { preferences: investmentPreferences } = useSelector((state: RootState) => state.user.investor) || {};

    const onClickClose = () => {
        setOpen(false);
    };

    const onClickOpen = () => {
        if (loading) {
            return;
        }
        if (!investmentPreferences || Object.keys(investmentPreferences).length === 0) {
            setOpen(true);
            return;
        }

        setLoading(true);
        Apis.downloadHistoricalDeals()
            .then((res) => {
                //download(data, `historicalDeals.xlsx`);
                download(
                    new Blob([res.data], { type: res.headers['content-type'] }),
                    'historicalDeals',
                    res.headers['content-type'],
                );
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ text: String(err), error: true }));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onClickProceed = () => {
        onClickClose();
        navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTMENT_PREFERENCES}`);
    };
    // const isDownloadShow = useMemo(() => {
    //     const { kyc, accreditation, profile } = investorStatus || {};
    //     return (
    //         kyc === InvestorStatus.KYCApproved &&
    //         accreditation === InvestorStatus.AIApproved &&
    //         profile === InvestorStatus.Approved
    //     );
    // }, [investorStatus]);
    return (
        <div>
            {/*  <div
                     className="flex cursor-pointer items-center transition ease-in-out delay-150  hover:translate-x-7 hover:scale-110  duration-300"
                     onClick={onClickOpen}
                 >
                      <div>
                     <p className="text-[white] uppercase font-[WorkSans-Semibold] font-bold text-base ">
                         Full Historical Deal Diary
                     </p> */}
            {/* <p className="text-[#20222B] font-[Lato] text-xs mt-2 md:mt-0">
                             (Only for fully onboarded investors)
                         </p>
                     </div>
                     {!loading && <MdOutlineFileDownload className="ml-1" size={'1.5rem'} color="#41D17E" />}
                     {loading && (
                         <div className="w-7 flex justify-center">
                             <Spin />
                         </div>
                     )}

                 </div> */}

            <LinkButton
                title="Full Historical Deal Diary"
                variant="light"
                onClick={onClickOpen}
                loading={loading}
                isArrow={true}
            />
            <Modal
                title="Download Historical Deals"
                open={open}
                footer={null}
                onCancel={onClickClose}
                centered
                closeIcon={<IoMdClose size={'1.2rem'} />}
            >
                <p className="text-sm " style={{ color: '#777777' }}>
                    Historical deal data is only available to investors with approved KYC status. Please complete your
                    KYC in order to access this document.
                </p>
                <div className="flex flex-col md:flex-row md:justify-end">
                    <div className="flex justify-end pt-4">
                        <HSButton title="proceed" onClick={onClickProceed} />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default DownloadHistoricalDeals;
